import { useRouter } from 'next/router';
import { getQueryParam } from '../utils/getQueryParam';

function usePageId(): number {
  const router = useRouter();

  return getQueryParam<number>(router.query, 'id', -1);
}

export default usePageId;
